// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"947bab1d","134":"f900b180","466":"f1d6190d","625":"677d8694","676":"afadd38b","873":"6dc5683a","929":"677d8694"}[chunkId] + ".chunk.css";
};